import { brandByKey } from "@school-sales-ai/shared";
import { useClientBranding } from "@/hooks/useClientBranding";
import { catalogNoun, type CatalogNoun } from "@/lib/brand";

/**
 * The active client's word for a catalog entry ("programa" / "producto").
 *
 * Reads the CLIENT's brand, never the hostname — this is authenticated chrome.
 * While `/crm/branding` is loading, `brandByKey(undefined)` resolves to the
 * default brand, so the screen renders the school wording rather than a blank.
 */
export function useCatalogNoun(): CatalogNoun {
  const { data } = useClientBranding();
  return catalogNoun(brandByKey(data?.brand));
}
